export var cacheTableData = {};
export var cacheTableServer = {};
export var cacheTableFilter = {};
export var cacheTablePage = {};
export var cacheTableOrderBy = {};
export var cacheTableRowsPerPage = {};
